import React, { useEffect, useRef, useState } from "react"
import styled from "styled-components"

const Video = styled.video`
  object-fit: cover;
`

export default ({ videoSource, videoTitle, width, thumbnail, noControls, autoPlay, muted, ...props }) => {
  // use implicit width to set relative height (16:9) of video
  const ref = useRef(null)
  const [iframeWidth, setIframeWidth] = useState(null)
  useEffect(() => {
    setIframeWidth(ref.current ? ref.current.offsetWidth : 0)
  }, [ref.current])
  const height = iframeWidth * .56

  const regex = /youtube.co\w+/g
  let url = videoSource
  let youtube = false
  if (videoSource) {
    youtube = videoSource.match(regex)
  }
  if (youtube) {
    url = url.replace("watch?v=", "embed/")
  }

  //console.log("video source", videoSource)

  // useEffect(() => {
  //   if (autoPlay) ref.current.play()
  // }, [])

  return (
    <div {...props}>
      {
        youtube ?
          (
            <iframe
              ref={ref}
              type="text/html"
              src={url}
              frameBorder="0"
              width="100%"
              height={height}
              title={videoTitle || "Embedded Video"}
            />
          )
          :
          (
            <div className="video">
              <Video
                ref={ref}
                onClick={() => ref.current.play()}
                controls={noControls ? "" : "controls"}
                width={width || 600}
                poster={thumbnail}
                loop={props.loop}
                autoPlay={autoPlay}
                muted={muted}
              >
                <source src={videoSource} type={`video/${videoSource.slice(-3)}`} />
                Your browser does not support the video tag.
              </Video>
              <div className="playpause" />
            </div>
          )
      }
    </div>
  )
}